import { render, staticRenderFns } from "./listen-audio.vue?vue&type=template&id=488d6958&scoped=true&"
import script from "./listen-audio.vue?vue&type=script&lang=js&"
export * from "./listen-audio.vue?vue&type=script&lang=js&"
import style0 from "./listen-audio.vue?vue&type=style&index=0&id=488d6958&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488d6958",
  null
  
)

export default component.exports